import { MissionsContainer } from "./Missions.styled"
import MissionsContent from "./MissionsContent"

export default function Missions({ intersectionRef, anchorRef }) {
  return (
    <MissionsContainer>
      <MissionsContent />
    </MissionsContainer>
  )
}
